import React from 'react'
import PropTypes from 'prop-types'
import { number, string, func } from 'prop-types'
import { connect } from 'react-redux'
import { ACTION_TYPES as types } from 'Constants'

const mapDispatchToProps = dispatch => ({
  dispatch
})

const TrackLinkHOC = props => {
  return (
    <div
      onClick={() => {
        if (props.id) {
          props.dispatch({
            type: types.TRACK_LINK,
            payload: {
              key: 'product',
              value: props.id,
              depth: props.depth
            }
          })
        }
      }}
    >
      {props.children}
    </div>
  )
}

TrackLinkHOC.defaultProps = {
  depth: 1,
  id: ''
}

TrackLinkHOC.propTypes = {
  children: PropTypes.node,
  dispatch: func,
  id: string,
  depth: number
}

export default connect(null, mapDispatchToProps)(TrackLinkHOC)
